import LoadingLayer from './LoadingLayer';

export default LoadingLayer;


// WEBPACK FOOTER //
// ./src/components/LoadingLayer/index.js